const ELM_NAME = 'main-faq';

class MainFAQ extends HTMLElement {
  clicked = false;

  handleBackToFaqClick = (event) => {
    const activeGroup = this.topicSections.find((section) =>
      section.classList.contains('topic-section-is-open')
    );

    if (activeGroup) {
      const delegateButton = this.topicButtons.find((button) => {
        return (
          button.getAttribute('data-topic-sections-collapsible-target-delegate') ===
          activeGroup.getAttribute('data-topic-sections-collapsible-target-delegate')
        );
      });

      if (delegateButton) {
        delegateButton.click();
        this.backToFaq.click();

        window.history.replaceState(null, null, ' ');
      }
    }
  };

  handleButtonClick = (event) => {
    event.preventDefault();

    this.clicked = true;

    this.topicButtons.forEach((button) => {
      if (button !== event.currentTarget) {
        button.classList.remove('topic-is-active');
      }
    });

    event.currentTarget.classList.toggle('topic-is-active');

    if (event.currentTarget.href) {
      // This prevents scrolling to the ID in JS envs.
      window.history.replaceState(null, null, event.currentTarget.href);
    }
  };

  handleResize = () => {
    if (!this.clicked && window.innerWidth >= 1024) {
      this.topicButtons[0].click();
    }
  };

  connectedCallback() {
    if (this.isConnected) {
      this.backToFaq = this.querySelector('[data-back-to-faq]');
      this.topicButtons = [...this.querySelectorAll('[data-topic-sections-collapsible-trigger]')];
      this.topicSections = [...this.querySelectorAll('[data-topic-sections-collapsible-group]')];
      this.mainFaqGroup = this.querySelector('[data-main-faq-collapsible-group]');

      if (
        this.backToFaq &&
        this.topicButtons.length &&
        this.topicSections.length &&
        this.mainFaqGroup
      ) {
        this.backToFaq.addEventListener('click', this.handleBackToFaqClick);
        this.topicButtons.forEach((button) => {
          button.addEventListener('click', this.handleButtonClick);
        });

        // If there is a hash then open the corresponding topic section
        if (window.location.hash) {
          const hash = window.location.hash.replace('#', '');
          const delegateButton = this.topicButtons.find((button) => {
            return button.getAttribute('data-topic-sections-collapsible-target-delegate') === hash;
          });

          if (delegateButton) {
            delegateButton.click();
          }
        } else {
          // If there is no hash then open the first topic section
          this.handleResize();

          window.addEventListener('resize', this.handleResize);
        }
      }
    }
  }
}

if (!customElements.get(ELM_NAME)) {
  customElements.define(ELM_NAME, MainFAQ);
}
